import { EndpointPath, legacyGetUrl, PublicApiUrls } from 'century-core/core-apis/ApiProvider';

export function getLearnURL(endpoint?: EndpointPath) {
  const url = legacyGetUrl(PublicApiUrls.Learn, undefined, endpoint);

  return url;
}
